export const reportError = (...params) => (_, {
  errorUtils
}) => {
  errorUtils.reportError(...params);
};